import { z } from 'zod';

export const siteImportSchema = z.object({
  name: z.string().min(3, 'Must be at least 3 characters'),
  slug: z
    .string()
    .length(4, 'Must be exactly 4 characters')
    .regex(/^[A-Z0-9]+$/, 'Letters and numbers only'),
  what3words: z
    .union([
      z
        .string()
        .regex(
          /^[a-zA-Z]+\.[a-zA-Z]+\.[a-zA-Z]+$/,
          'Must be word.word.word format'
        ),
      z.literal(''),
    ])
    .optional(),
  notes: z.string().optional(),
  latitude: z.number().nullable().optional(),
  longitude: z.number().nullable().optional(),
});

export type SiteImportFormData = z.infer<typeof siteImportSchema>;
